export default __webpack_public_path__ + "static/media/logo-small.260aa8b6.svg";